<body class="external-page sb-l-c sb-r-c">


    <!-- Start: Main -->
    <div id="main" class="animated fadeIn">

        <!-- Start: Content-Wrapper -->
        <section id="content_wrapper">

            <!-- begin canvas animation bg -->
            <div id="canvas-wrapper">
                <canvas id="demo-canvas"></canvas>
            </div>

            <!-- Begin: Content -->
            <section id="content" class="">

                <div class="admin-form theme-info mw700" style="margin-top: 3%;" id="login1">

                    <div class="row mb15 table-layout">

                        <div class="col-xs-6 va-m pln">
                            <a routerLink="/login" title="Return to Dashboard">
                              <img src="assets/img/logolargo.png" title="AdminDesigns Logo" class="img-responsive w250">
                            </a>
                        </div>

                        <div class="col-xs-6 text-right va-b pr5">
                            <div class="login-links">
                                <a [routerLink]="['/login']" class="" title="Sign In">Sign In</a>


                            </div>

                        </div>

                    </div>

                    <div class="panel panel-info mt10 br-n">

                        <div class="panel-heading heading-border bg-white">
                            <!--  <div class="section row mn">
                                <div class="col-sm-4">
                                    <a href="#" class="button btn-social facebook span-left mr5 btn-block">
                                        <span>
                                           <i class="fa fa-facebook"></i>
                                         </span>Facebook</a>
                                </div>
                                <div class="col-sm-4">
                                    <a href="#" class="button btn-social twitter span-left mr5 btn-block">
                                        <span>
                                           <i class="fa fa-twitter"></i>
                                         </span>Twitter</a>
                                </div>
                                <div class="col-sm-4">
                                    <a href="#" class="button btn-social googleplus span-left btn-block">
                                        <span>
                                           <i class="fa fa-google-plus"></i>
                                         </span>Google+</a>
                                </div>
                            </div>-->
                        </div>

                        <form ngNativeValidate [formGroup]="forma" (ngSubmit)="registerUser()" id="forma">

                            <div class="panel-body p25 bg-light">
                                <div class="section-divider mt10 mb40">
                                    <span>Set up your account</span>
                                </div>
                                <!-- .section-divider -->

                                <div class="section row">
                                    <div class="col-md-6">
                                        <label for="firstname" class="field prepend-icon">
                                              <input type="text" formControlName="firstname" name="firstname" id="firstname" class="gui-input" placeholder="First name...">
                                              <label for="firstname" class="field-icon">
                                                <i class="fa fa-user"></i>
                                              </label>
                                        </label>
                                    </div>
                                    <!-- end section -->

                                    <div class="col-md-6">
                                        <label for="lastname" class="field prepend-icon">
                                          <input type="text" formControlName="lastname" name="lastname" id="lastname" class="gui-input" placeholder="Last name...">
                                          <label for="lastname" class="field-icon">
                                            <i class="fa fa-user"></i>
                                          </label>
                                        </label>
                                    </div>
                                    <!-- end section -->
                                </div>
                                <!-- end .section row section -->

                                <div class="section">
                                    <label for="email" class="field prepend-icon">
                                        <input type="email" formControlName="email" name="email" id="email" class="gui-input" required placeholder="Email address">
                                        <label for="email" class="field-icon">
                                          <i class="fa fa-envelope"></i>
                                        </label>
                                    </label>
                                </div>
                                <!-- end section -->


                                <div class="section">
                                    <label for="password" class="field prepend-icon">
                                       <input type="password" formControlName="password" name="password" id="password" class="gui-input" placeholder="Create a password">
                                       <label for="password" class="field-icon">
                                         <i class="fa fa-unlock-alt"></i>
                                       </label>
                                    </label>
                                </div>
                                <!-- end section -->

                                <div class="section">
                                    <label for="confirmPassword" class="field prepend-icon">
                                        <input type="password" formControlName="password2" name="password2" id="password2" class="gui-input" placeholder="Retype your password">
                                        <label for="confirmPassword" class="field-icon">
                                          <i class="fa fa-lock"></i>
                                        </label>
                                    </label>
                                </div>

                                <div *ngIf="forma.errors?.samePassword  && forma.pristine">
                                    <div class="alert alert-danger" role="alert">
                                        Password you must same
                                    </div>
                                </div>
                                <!-- end section -->

                                <div class="section-divider mv40">
                                    <span>Review the Terms</span>
                                </div>
                                <!-- .section-divider -->

                                <div class="section mb15">

                                    <label class="option block mt15">
                                       <input formControlName="terms" type="checkbox" name="terms" id="terms">
                                       <span class="checkbox"></span>I agree to the
                                       <a href="#" class="theme-link"> terms of use. </a>
                                     </label>
                                </div>
                                <!-- end section -->

                            </div>
                            <!-- end .form-body section -->
                            <div class="panel-footer clearfix">
                                <button type="submit" class="button btn-primary pull-right">Create Account</button>
                            </div>
                            <!-- end .form-footer section -->
                        </form>
                    </div>
                </div>

            </section>
            <!-- End: Content -->

        </section>
        <!-- End: Content-Wrapper -->

    </div>
    <!-- End: Main -->

    <!-- BEGIN: PAGE SCRIPTS -->



    <!-- END: PAGE SCRIPTS -->

</body>
